"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QuestDetailsWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _QuestDetailsWindowModule = _interopRequireDefault(require("./QuestDetailsWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _inputElements = require("../../../inputElements");

var _entities = require("../../../entities");

var _item = _interopRequireDefault(require("../../../../mocks/item"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _QuestDetailsWindow = _interopRequireDefault(require("./QuestDetailsWindow.i18n"));

var _Money = _interopRequireDefault(require("../../../common/Money/Money"));

var _moneyToMoneyDivided = _interopRequireDefault(require("../../../../helpers/money/moneyToMoneyDivided"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// TODO: make text (ReactNode) dynamic via props
function QuestDetailsWindow(_ref) {
  var _ref$initialTab = _ref.initialTab,
      initialTab = _ref$initialTab === void 0 ? "QUEST" : _ref$initialTab,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(initialTab),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      activeObjectiveIndex = _useState4[0],
      setActiveObjectiveIndex = _useState4[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_QuestDetailsWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _QuestDetailsWindowModule.default.dragHandler,
    classNameCloseBtn: _QuestDetailsWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.tabs
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _EButtonType.default.QUEST_USER,
    onClick: function onClick() {
      return setActiveTab("QUEST");
    },
    isDisabled: activeTab === "QUEST"
  }, formatMessage(_QuestDetailsWindow.default.quest)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _EButtonType.default.QUEST_USER,
    onClick: function onClick() {
      return setActiveTab("REWARD");
    },
    isDisabled: activeTab === "REWARD"
  }, formatMessage(_QuestDetailsWindow.default.reward))), activeTab === "QUEST" && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_QuestDetailsWindowModule.default.content, _QuestDetailsWindowModule.default.quest)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.description
  }, "Hee hee hee... Looking for work? I think we can help each other out. I am a merchant and I sell rings, necklaces, handbags... I have quite a few valuable things, hee hee. Lately there has been a huge demand for brooches by local women. Of course, they only want the best quality. Have you heard about Nymph Lake? On the northern side you should find some Small Black Bears. They are quite tough, but their teeth are so smooth... Im pretty sure I could make some beautiful brooches with those teeth. Could you bring me some? About 15 of them should be enough."), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.titles
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.title
  }, "Elia Baski wants you to bring her 15 Small Black ", "Bear's", " teeth.")), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.objectives
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.objective
  }, /*#__PURE__*/_react.default.createElement("a", {
    onClick: function onClick() {
      return setActiveObjectiveIndex(0);
    },
    className: (0, _classnames.default)(activeObjectiveIndex === 0 && _QuestDetailsWindowModule.default.isActive)
  }, "o. Small Black ", "Bear's", " Teeth 0/15")), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.objective
  }, /*#__PURE__*/_react.default.createElement("a", {
    onClick: function onClick() {
      return setActiveObjectiveIndex(1);
    },
    className: (0, _classnames.default)(activeObjectiveIndex === 1 && _QuestDetailsWindowModule.default.isActive)
  }, "o. You have to go to Elia Baskin (Grocer)")))), activeTab === "REWARD" && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_QuestDetailsWindowModule.default.content, _QuestDetailsWindowModule.default.reward)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.expAndMoney
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.exp
  }, "302"), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.money
  }, /*#__PURE__*/_react.default.createElement(_Money.default, {
    moneyDivide: (0, _moneyToMoneyDivided.default)(4300),
    showNullValues: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.items
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestDetailsWindowModule.default.itemsTitle
  }, "SELECTION ITEM"), /*#__PURE__*/_react.default.createElement(_entities.Item, {
    item: _item.default
  }))));
}